import React from 'react'
import { RouteProps } from '../../routes/AppRouter'
import { UserDetail as UD } from '../../features/users'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

export function UserDetail(props: RouteProps) {
  const { setTitle } = useTitleHeaderContext()
  setTitle(props.title || '')

  return <UD id={props.id} />
}
